import Css from "./Customer.module.css";
import {
    Row,
    Col,
    Form,
    Button,
    Tab,
    Table,
    InputGroup,
} from "react-bootstrap";

export default function CustomerData({ stepPage = 1, data = undefined, disabled = false }) {
    return (
        <div className={Css.Register_customer_layout1 + ' h-auto'}>
            <label className={Css.colorfont}>
                <h6>ข้อมูลผู้ติดต่อ</h6>
            </label>
            <br />

            <div>
                <Row className={`mb-2 ${Css.body2}`}>
                    <Col>
                        <Form.Group>
                            <Form.Label className={Css.colorlabel}>ชื่อ</Form.Label>
                            {
                                disabled === true &&
                                <Col>
                                    <Form.Text className="fs-6">{data?.user_first_name}</Form.Text>
                                </Col>
                            }
                            {
                                disabled === false &&
                                <Form.Control placeholder="" name={"user_first_name"} value={data?.user_first_name} />
                            }

                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group>
                            <Form.Label className={Css.colorlabel}>สกุล</Form.Label>
                            {
                                disabled === true &&
                                <Col>
                                    <Form.Text className="fs-6">{data?.user_last_name}</Form.Text>
                                </Col>
                            }
                            {
                                disabled === false &&
                                <Form.Control placeholder="" name={"last_name"} value={data?.user_last_name} />
                            }

                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className={`mb-2 ${Css.body2}`}>
                    <Form.Label className={Css.colorlabel}>หมายเลขโทรศัพท์</Form.Label>
                    {
                        disabled === true &&
                        <Col>
                            <Form.Text className="fs-6">{data?.user_tel}</Form.Text>
                        </Col>
                    }
                    {
                        disabled === false &&
                        <Form.Control placeholder="" name={"phonenumber"} value={data?.user_tel} />
                    }

                </Form.Group>
                <Form.Group className={` ${Css.body2}`}>
                    <Form.Label className={Css.colorlabel}>อีเมล</Form.Label>
                    {
                        disabled === true &&
                        <Col>
                            <Form.Text className="fs-6">{data?.user_email}</Form.Text>
                        </Col>
                    }
                    {
                        disabled === false &&
                        <Form.Control placeholder="" name={"email"} value={data?.user_email} />
                    }

                </Form.Group>
            </div>
        </div>
    );
}